
import { createReducer, on } from '@ngrx/store';
import { loadCorporateSignupConfigData, loadCorporateSignupConfigDataSuccess, loadCorporateSignupConfigDataFailure } from '../actions/corporateSignupConfig.actions';

export interface State {
  corporateSignupConfigData: any[];
  loading: boolean;
  error: string | null;
}

export const initialState: State = {
  corporateSignupConfigData: [],
  loading: false,
  error: null,
};

export const corporateSignupConfigReducer = createReducer(
  initialState,
  on(loadCorporateSignupConfigData, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(loadCorporateSignupConfigDataSuccess, (state, { corporateSignupConfigData }) => {
    console.log({corporateSignupConfigData})
    return ({
    ...state,
    loading: false,
    corporateSignupConfigData: corporateSignupConfigData,
  })}),
  on(loadCorporateSignupConfigDataFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);
